<template>
    <div class="loader" v-if="isLoading">
        <span class="loader__spinner"></span>
        <p class="loader__text">{{ text }}</p>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        text: {
            type: String,
            default: 'Loading...'
        }
    },
    computed: { ...mapGetters(['isLoading']) }
}
</script>